import { FC } from 'react';
import { Skeleton } from '../../../../feedback/Skeleton';
import { Flex } from '../../../../layout/Flex';
import { ListItem } from '../../styles';

export const CollectionListItemSkeleton: FC = () => (
    <ListItem p={1} role="button">
        <Flex direction="row" alignItems="center" spacing={2} width="100%">
            <Skeleton variant="rect" width={48} height={48} borderRadius={1} />
            <Flex flexGrow={1}>
                <Skeleton variant="text" width="100%" height={24} />
                <Skeleton variant="text" width="30%" height={16} />
            </Flex>
        </Flex>
    </ListItem>
);
